module.exports = __webpack_public_path__ + "img/CalendarIcon.30a791aa.svg";